import { yupResolver } from "@hookform/resolvers/yup";
import { AlertColor } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import ButtonGeneric from "../../components/ButtonGeneric";
import InputGeneric from "../../components/InputGeneric";
import PageWrapper from "../../components/PageWrapper/index";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";
import { FormCustomerCategoryRegisterPage } from "./styles";

type customerCategoryFormTypeValues = {
    name: string;
    description?: string;
    color?: string;
};

const customerCategoryFormSchema = yup.object().shape({
    name: yup.string().required(),
    description: yup.string().required(),
    color: yup.string().required(),
});

function CustomerCategoryRegisterPage() {
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("usuario.listar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<customerCategoryFormTypeValues>({
        resolver: yupResolver(customerCategoryFormSchema),
    });

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const createNewHolderType: SubmitHandler<
        customerCategoryFormTypeValues
    > = async (formValues) => {
        setIsLoadingButton(true);
        api.post(`/customersCategory`, {
            name: formValues.name,
            description: formValues.description,
            color: formValues.color,
        })
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    navigate("/settings/customersCategories");
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.response.name);
                setIsLoadingButton(false);
            });
    };

    return (
        <PageWrapper>
            <FormCustomerCategoryRegisterPage>
                <div className="topFormPage">
                    <h2>Cadastrar Categoria de Cliente</h2>
                </div>
                <form onSubmit={handleSubmit(createNewHolderType)}>
                    <div className="inputsContainer">
                        <Controller
                            control={control}
                            name="name"
                            render={({
                                field: { onChange, onBlur, value = "", ref },
                            }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    size="small"
                                    className="inputs"
                                    label="Nova categoria de cliente"
                                    error={!!errors.name}
                                    ref={ref}
                                    autoFocus
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            name="description"
                            render={({
                                field: { onChange, onBlur, value = "", ref },
                            }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    minRows="3"
                                    maxRows="5"
                                    multiline
                                    size="small"
                                    className="inputs"
                                    label="Digite uma descrição"
                                    error={!!errors.description}
                                    ref={ref}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            name="color"
                            render={({ field: { onChange, onBlur, ref } }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    type="color"
                                    defaultValue="#000000"
                                    size="small"
                                    className="inputs"
                                    label="Defina uma cor para a categoria"
                                    error={!!errors.color}
                                    ref={ref}
                                />
                            )}
                        />
                    </div>
                    <div className="buttonsContainer">
                        <ButtonGeneric
                            onclick={() =>
                                navigate("/settings/customersCategories")
                            }
                            buttonColor="var(--cancel)"
                            text="VOLTAR"
                        />
                        <PreloadButton
                            colorText="white"
                            background="var(--confirm)"
                            loading={isLoadingButton}
                            text="CONFIRMAR"
                            type="submit"
                        />
                    </div>
                </form>
                <Toast
                    open={openToast}
                    onClose={() => handleCloseToast()}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </FormCustomerCategoryRegisterPage>
        </PageWrapper>
    );
}
export default CustomerCategoryRegisterPage;
